document.addEventListener('DOMContentLoaded', function() {
  const selectors = {
    list: '.currency-selector__list',
    list_item: '.currency-selector__list-item',
    button: '.currency-selector__button',
  };

  const classes = {
    active: 'active',
  };

  class CurrencySelector extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.activeCurrencyCode = this.container.dataset.currencyCode;
      this.currentUrl = window.location.href;

      // Global-e to replace with Shopify Markets
      this.currencyOptions = {
        aud: {
          country: 'Australia',
          symbol: '$',
          code: 'AUD',
        },
          usd: {
          country: 'United States',
          symbol: '$',
          code: 'USD',
        },
        cad: {
          country: 'Canada',
          symbol: '$',
          code: 'CAD',
        },
        nzd: {
          country: 'New Zealand',
          symbol: '$',
          code: 'NZD',
        },
        gbp: {
          country: 'United Kingdom',
          symbol: '£',
          code: 'GBP',
        },
        eur: {
          country: 'Europe',
          symbol: '€',
          code: 'EUR',
        },
        sgd: {
          country: 'Singapore',
          symbol: 'S$',
          code: 'SGD',
        },
        cny: {
          country: 'China',
          symbol: '¥',
          code: 'CNY',
        }, 
        hkd: {
          country: 'Hong Kong',
          symbol: '$',
          code: 'HKD',
        }, 
        jpy: {
          country: 'Japan',
          symbol: '¥',
          code: 'JPY',
        },
        row: {
          country: 'Rest of the World',
          symbol: '$',
          code: 'USD',
        },
      };

      this.init();
    }

    init() {
      const list = this.container?.querySelector(selectors.list);
      const button = this.container?.querySelector(selectors.button);

      if (!list || !button) return;

      this.renderOptions(list);
      button?.addEventListener('click', e => this.toggleActive());
    }

    toggleActive() {
      this.container.classList.toggle(classes.active);
    }

    renderOptions(list) {
      if (!list) return;

      Object.values(this.currencyOptions).forEach(currency => {
        const code = currency.code;
        // Assumes global-e will also set the currency.iso_code
        const isActive = code === this.activeCurrencyCode;

        let li = document.createElement('li');
        li.textContent = `${currency.country} ${currency.symbol}${currency.code}`;
        li.classList = isActive ? 'active' : '';
        list.appendChild(li);

        li.addEventListener('click', () => this.changeCurrency(currency));
      });
    }

    changeCurrency(currency) {
      console.log("change currency", currency);
      this.toggleActive();
      const url = new URL(window.location.href);


      console.log("url", url);

      window.location = `https://${url.hostname}${url.pathname}?currency=${currency.code}`;

      /*if ( !url.hostname.includes('au.') && (currency.code === 'AUD' || currency.code === 'NZD')) {
        window.location.href = `https://au.${url.hostname}${url.pathname}?currency=${currency.code}`;
        return;
      }

      if ( url.hostname.includes('au.') && currency.code !== 'AUD' &&  currency.code !== 'NZD') {
        const primaryDomain = url.hostname.replace(/^[^.]+\./g, '');
        window.location.href = `https://${primaryDomain}${url.pathname}?currency=${currency.code}`;
        return;
      }

      if ( url.hostname.includes('au') && (currency.code === 'AUD' || currency.code === 'NZD') ) {
        window.location.href = `https://${url.hostname}${url.pathname}?currency=${currency.code}`;
        return;
      }

      this.globalE(currency);*/
    }

    globalE(currency) {
      // Global e to wrtie code here
    }
  }

  if (!customElements.get('currency-selector')) {
    customElements.define('currency-selector', CurrencySelector);
  }
});
